var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOrgPost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_7166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.84422 8.95373C2.3481 8.7608 2.10004 8.66433 2.02761 8.52533C1.96483 8.40483 1.96475 8.26129 2.02739 8.14071C2.09965 8.00163 2.34759 7.90486 2.84349 7.71134L16.9166 2.21939C17.3643 2.0447 17.5881 1.95736 17.7311 2.00514C17.8553 2.04663 17.9528 2.1441 17.9943 2.26831C18.0421 2.41133 17.9547 2.63516 17.78 3.08281L12.2881 17.1559C12.0946 17.6518 11.9978 17.8998 11.8587 17.972C11.7381 18.0347 11.5946 18.0346 11.4741 17.9718C11.3351 17.8994 11.2386 17.6513 11.0457 17.1552L8.85559 11.5235C8.81643 11.4228 8.79685 11.3725 8.7666 11.3301C8.7398 11.2925 8.70693 11.2596 8.66935 11.2328C8.62695 11.2026 8.5766 11.183 8.47589 11.1438L2.84422 8.95373Z",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_7166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrgPost);
export default __webpack_public_path__ + "static/media/IconOrgPost.8d9980b7e6f5f9cd611e131e3daebafe.svg";
export { ForwardRef as ReactComponent };